import React, { useState, useEffect, useRef, Children } from "react";
import axios from "axios";
import COM_Upload_IMG from "../Component/COM_Upload_IMG";
import COM_Upload_IMG_v2 from "../Component/COM_Upload_IMG_v2";
import COM_Upload_IMG_v2__AllCafe from "../Component/COM_Upload_IMG_v2__AllCafe";

import "../Styles/gamedp.css";

// ------------------------------------------------- MUI Table 1/3
import {
  Table,
  Button,
  TextInput,
  Modal,
  MantineProvider,
} from "@mantine/core";
import { Calendar } from "@mantine/dates";

import "../Styles/careu.css";
import "../Styles/COM_FileUpload_v2.css";
import Comp_CareU_Buffet from "../Component/Comp_CareU_Buffet";
const { REACT_APP_ECLIPSE_API } = process.env;

const Page_CareU = () => {
  //  ----------------------------------------------------------------------------------------- database

  const [DB_AllCafeInfo, setBD_AllCafeInfo] = useState([]);
  const get_DB_GetAllCafeList = (dt_from, dt_until) => {
    axios
      //REACT_APP_ECLIPSE_API
      .post(`${REACT_APP_ECLIPSE_API}/get__cafe_adv_list__allcafeinfo`)
      .then((res) => {
        // setBD_CafeHardware(res.data);

        console.log("get_DB_GetAllCafeList", res?.data);
        setBD_AllCafeInfo(res?.data);
      });
  };

  const set_adv_enabled_all = (adv_type, adv_enabled) => {
    const confirmed = window.confirm(`Preoceed ?`);
    if (!confirmed) {
      return; // User clicked "No"
    }

    axios
      //REACT_APP_ECLIPSE_API
      .post(`${REACT_APP_ECLIPSE_API}/set__cafe_adv_list__adv_enabled_all`, {
        adv_type,
        adv_enabled,
      })
      .then((res) => {
        // setBD_CafeHardware(res.data);

        console.log("set_adv_enabled_all", res?.data);
        get_DB_GetAllCafeList();
      });
  };

  const set_visible_from_dt_all = (adv_type, visible_from_dt) => {
    const confirmed = window.confirm(`Preoceed ?`);
    if (!confirmed) {
      return; // User clicked "No"
    }

    axios
      //REACT_APP_ECLIPSE_API
      .post(
        `${REACT_APP_ECLIPSE_API}/set__cafe_adv_list__visible_from_dt_all`,
        {
          adv_type,
          visible_from_dt,
        }
      )
      .then((res) => {
        // setBD_CafeHardware(res.data);

        console.log("set_visible_from_dt_all", res?.data);
        get_DB_GetAllCafeList();
      });
  };

  const set_visible_until_dt_all = (adv_type, visible_until_dt) => {
    const confirmed = window.confirm(`Preoceed ?`);
    if (!confirmed) {
      return; // User clicked "No"
    }

    axios
      //REACT_APP_ECLIPSE_API
      .post(
        `${REACT_APP_ECLIPSE_API}/set__cafe_adv_list__visible_until_dt_all`,
        {
          adv_type,
          visible_until_dt,
        }
      )
      .then((res) => {
        // setBD_CafeHardware(res.data);

        console.log("set_visible_until_dt_all", res?.data);
        get_DB_GetAllCafeList();
      });
  };

  const set_adv_name_all = (adv_type, adv_name) => {
    const confirmed = window.confirm(`Preoceed ?`);
    if (!confirmed) {
      return; // User clicked "No"
    }

    axios
      //REACT_APP_ECLIPSE_API
      .post(`${REACT_APP_ECLIPSE_API}/set__cafe_adv_list__adv_name_all`, {
        adv_type,
        adv_name,
      })
      .then((res) => {
        // setBD_CafeHardware(res.data);

        console.log("set_adv_name_all", res?.data);
        get_DB_GetAllCafeList();
      });
  };

  const set_adv_url_all = (adv_type, adv_url) => {
    const confirmed = window.confirm(`Preoceed ?`);
    if (!confirmed) {
      return; // User clicked "No"
    }

    axios
      //REACT_APP_ECLIPSE_API
      .post(`${REACT_APP_ECLIPSE_API}/set__cafe_adv_list__adv_url_all`, {
        adv_type,
        adv_url,
      })
      .then((res) => {
        // setBD_CafeHardware(res.data);

        console.log("set_adv_url_all", res?.data);
        get_DB_GetAllCafeList();
      });
  };

  const set_adv_exepath_all = (adv_type, adv_exepath) => {
    const confirmed = window.confirm(`Preoceed ?`);
    if (!confirmed) {
      return; // User clicked "No"
    }

    axios
      //REACT_APP_ECLIPSE_API
      .post(`${REACT_APP_ECLIPSE_API}/set__cafe_adv_list__adv_exepath_all`, {
        adv_type,
        adv_exepath,
      })
      .then((res) => {
        // setBD_CafeHardware(res.data);

        console.log("set_adv_exepath_all", res?.data);
        get_DB_GetAllCafeList();
      });
  };

  //  ----------------------------------------------------------------------------------------- global theme
  const theme = {
    colorScheme: "dark", // 🌙 Enables dark mode
    primaryColor: "orange", // 🔶 Changes primary to orange
    colors: {
      orange: [
        "#fff4e6",
        "#ffe8cc",
        "#ffd8a8",
        "#ffc078",
        "#ffa94d",
        "#ff922b",
        "#fd7e14",
        "#f76707",
        "#e8590c",
        "#d9480f",
      ],
    },
  };
  //  ----------------------------------------------------------------------------------------- global variables
  const [selectedCafe, setSelectedCafe] = useState("Gift BBA");
  const [opened_Col1, setOpened_Col1] = useState(false);

  const [selectedDisplayType, setSelectedDisplayType] = useState("");

  const [selected_adv_name_P, setSelected_adv_name_P] = useState();
  const [selected_adv_url_P, setSelected_adv_url_P] = useState();
  const [selected_adv_exepath_P, setSelected_adv_exepath_P] = useState();

  useEffect(() => {
    get_DB_GetAllCafeList();
    console.log("p2");
  }, [selectedCafe]);

  return (
    <MantineProvider withGlobalStyles withNormalizeCSS theme={theme}>
      <div className="CU_Body ">
        <div className="CU_FlexColumn">
          <h1>Care U Setting</h1>
          <div className="CU_FlexRow CU_FlexWarp">
            {DB_AllCafeInfo?.cafelist?.map((x, xi) => {
              return (
                <Button
                  key={xi}
                  variant={selectedCafe === x?.cafe_name ? "filled" : "outline"}
                  color="orange"
                  onClick={() => {
                    setSelectedCafe(x?.cafe_name);
                  }}
                >
                  {x?.cafe_name}
                </Button>
              );
            })}
          </div>

          <br />
          {/* <COM_Upload_IMG_v2
          lable="Photo 1"
          sto_DirPath={`/uploads/Eclipse_CareU/img/`}
          sto_FileName={`${"zzzzzz" + "__desc2"}.png`}
          COM_Width="10rem"
          COM_Height="15rem"
          COM_fontsize=".5rem"
        /> */}
          {/* img_Gift_BBA__Poster_Main__0__Top.png */}
          {/* img_Gift_BBA__Poster_Main__0__Middle.png */}
          {/* img_Gift_BBA__Poster_Main__0__Bottom.jpg */}
          <b style={{ color: "red" }}>
            *** Make sure the is suitable resolution and minimized the file size
            for better loading speed at client pc
          </b>
          <div className="CU_FlexRow">
            <Button
              variant={selectedDisplayType === "poster" ? "filled" : "outline"}
              color="orange"
              onClick={() => {
                setSelectedDisplayType("poster");
              }}
            >
              Desktop Poster
            </Button>
            <Button
              variant={selectedDisplayType === "buffet" ? "filled" : "outline"}
              color="orange"
              onClick={() => {
                setSelectedDisplayType("buffet");
              }}
            >
              Buffet
            </Button>
          </div>
          {selectedDisplayType === "poster" ? (
            <div>
              {DB_AllCafeInfo?.cafelist
                ?.filter((f) => {
                  return f.cafe_name === selectedCafe;
                })
                ?.map((x, xi) => (
                  <div className="CU_Overflow_Child" key={xi}>
                    <Button
                      size="xl"
                      color="lime"
                      variant={opened_Col1 ? "filled" : "outline"}
                      onClick={() => setOpened_Col1((o) => !o)}
                    >
                      Update All Cafe Image at Once
                    </Button>

                    {/* ------------------------------------------ Modal */}
                    <Modal
                      opened={opened_Col1}
                      onClose={() => setOpened_Col1(false)}
                      // className="CU_Box_Group"
                      size="100%"
                      zIndex="99999"
                    >
                      <div className="CU_Gap_1">
                        <h2>Update All Cafe (Overwrite all Image Only)</h2>

                        {/* ---------------------------------------------- all cafe main1 */}
                        <div className="CU_FlexRow CU_Box_Group">
                          <div style={{ width: "40rem" }}>
                            <h2>main1</h2>
                            <div className="CU_FlexRow">
                              <Button
                                color="lime"
                                variant="subtle"
                                onClick={() => {
                                  // set_adv_enabled__byid(data?.id, +!data?.adv_enabled);
                                  set_adv_enabled_all("main1", 1);
                                }}
                              >
                                Set Enabled - All Cafe
                              </Button>
                              <Button
                                color="red"
                                variant="subtle"
                                onClick={() => {
                                  // set_adv_enabled__byid(data?.id, +!data?.adv_enabled);
                                  set_adv_enabled_all("main1", 0);
                                }}
                              >
                                Set Disabled - All Cafe
                              </Button>
                            </div>

                            <div className="CU_FlexRow">
                              <CalendarPicker
                                label="Start From"
                                // value={data?.visible_from_dt}
                                onDateChange={(e) => {
                                  console.log("e3", e);
                                  set_visible_from_dt_all("main1", e);
                                  // set_visible_from_dt__byid(data?.id, e);
                                }}
                              />
                              <CalendarPicker
                                label="finished Until"
                                // value={data?.visible_from_dt}
                                onDateChange={(e) => {
                                  console.log("e3", e);
                                  set_visible_until_dt_all("main1", e);
                                  // set_visible_from_dt__byid(data?.id, e);
                                }}
                              />
                            </div>
                            {/* {`adv_name : ${data?.adv_name} `} */}
                            <div className="CU_FlexRow CU_AlignItem_FlexEnd">
                              <TextInput
                                label="adv name (for log report)"
                                w="100%"
                                value={selected_adv_name_P}
                                placeholder="adv_name_P"
                                onChange={(event) =>
                                  setSelected_adv_name_P(
                                    event.currentTarget.value
                                  )
                                }
                              />
                              <Button
                                color="red"
                                variant="outline"
                                onClick={() => {
                                  console.log(
                                    "selected_adv_name_P",
                                    selected_adv_name_P
                                  );
                                  set_adv_name_all(
                                    "main1",
                                    selected_adv_name_P
                                  );
                                }}
                              >
                                Update
                              </Button>
                            </div>

                            {/* {`adv_url : ${data?.adv_url}`} */}
                            <div className="CU_FlexRow CU_AlignItem_FlexEnd">
                              <TextInput
                                label="open url when click (to disabled just remove all the text)"
                                w="100%"
                                value={selected_adv_url_P}
                                placeholder="adv_url"
                                onChange={(event) =>
                                  setSelected_adv_url_P(
                                    event.currentTarget.value
                                  )
                                }
                              />
                              <Button
                                color="red"
                                variant="outline"
                                onClick={() => {
                                  console.log(
                                    "selected_adv_url_P",
                                    selected_adv_url_P
                                  );
                                  set_adv_url_all("main1", selected_adv_url_P);
                                }}
                              >
                                Update
                              </Button>
                            </div>
                            {/* {`adv_exepath : ${data?.adv_exepath}`} */}
                            <div className="CU_FlexRow CU_AlignItem_FlexEnd">
                              <TextInput
                                label="open exe when click (to disabled just remove all the text)"
                                w="100%"
                                value={selected_adv_exepath_P}
                                placeholder="adv_exepath"
                                onChange={(event) =>
                                  setSelected_adv_exepath_P(
                                    event.currentTarget.value
                                  )
                                }
                              />
                              <Button
                                color="red"
                                variant="outline"
                                onClick={() => {
                                  console.log(
                                    "selected_adv_exepath_P",
                                    selected_adv_exepath_P?.replaceAll(
                                      "\\",
                                      "\\\\"
                                    )
                                  );
                                  set_adv_exepath_all(
                                    "main1",
                                    selected_adv_exepath_P?.replaceAll(
                                      "\\",
                                      "\\\\"
                                    )
                                  );
                                }}
                              >
                                Update
                              </Button>
                              {/* {selected_adv_exepath?.replaceAll("\\", "\\\\")} */}
                            </div>
                          </div>

                          <div>
                            <COM_Upload_IMG_v2__AllCafe
                              COM_Label="All Cafe - Main Top Layer"
                              sto_DirPath={`./uploads/Eclipse_CareU/img/`}
                              // sto_FileName={`${fileNameToUpdload}__Top.png`}

                              // sto_FileName_List={[
                              //   `test_1.png`,
                              //   `test_2.png`,
                              //   `test_3.png`,
                              // ]}

                              sto_FileName_List={DB_AllCafeInfo?.cafelist?.map(
                                (x) => {
                                  let formatedCafeName = x?.cafe_name.replace(
                                    /\s+/g,
                                    "_"
                                  );

                                  // img_Gift_BBA__Poster_Main1__Bottom.jpg
                                  let tempFileName = `img_${formatedCafeName}__Poster_Main1__Top.png`;
                                  return tempFileName;
                                }
                              )}
                              COM_Width="15rem"
                              COM_Height="20rem"
                              COM_fontsize=".5rem"
                            />
                          </div>

                          <div>
                            <COM_Upload_IMG_v2__AllCafe
                              COM_Label="All Cafe - Main Middle Layer"
                              sto_DirPath={`./uploads/Eclipse_CareU/img/`}
                              // sto_FileName={`${fileNameToUpdload}__Top.png`}

                              sto_FileName_List={DB_AllCafeInfo?.cafelist?.map(
                                (x) => {
                                  let formatedCafeName = x?.cafe_name.replace(
                                    /\s+/g,
                                    "_"
                                  );

                                  // img_Gift_BBA__Poster_Main1__Bottom.jpg
                                  let tempFileName = `img_${formatedCafeName}__Poster_Main1__Middle.png`;
                                  return tempFileName;
                                }
                              )}
                              COM_Width="15rem"
                              COM_Height="20rem"
                              COM_fontsize=".5rem"
                            />
                          </div>
                          <div>
                            <COM_Upload_IMG_v2__AllCafe
                              COM_Label="All Cafe - Main Bottom Layer"
                              sto_DirPath={`./uploads/Eclipse_CareU/img/`}
                              // sto_FileName={`${fileNameToUpdload}__Top.png`}

                              sto_FileName_List={DB_AllCafeInfo?.cafelist?.map(
                                (x) => {
                                  let formatedCafeName = x?.cafe_name.replace(
                                    /\s+/g,
                                    "_"
                                  );

                                  // img_Gift_BBA__Poster_Main1__Bottom.jpg
                                  let tempFileName = `img_${formatedCafeName}__Poster_Main1__Bottom.jpg`;
                                  return tempFileName;
                                }
                              )}
                              COM_Width="15rem"
                              COM_Height="20rem"
                              COM_fontsize=".5rem"
                            />
                          </div>
                        </div>
                        <br />
                        {/* ---------------------------------------------- all cafe sub1 */}
                        <div className="CU_FlexRow CU_Box_Group">
                          <div style={{ width: "40rem" }}>
                            <h2>sub1</h2>
                            <div className="CU_FlexRow">
                              <Button
                                color="lime"
                                variant="subtle"
                                onClick={() => {
                                  // set_adv_enabled__byid(data?.id, +!data?.adv_enabled);
                                  set_adv_enabled_all("sub1", 1);
                                }}
                              >
                                Set Enabled - All Cafe
                              </Button>
                              <Button
                                color="red"
                                variant="subtle"
                                onClick={() => {
                                  // set_adv_enabled__byid(data?.id, +!data?.adv_enabled);
                                  set_adv_enabled_all("sub1", 0);
                                }}
                              >
                                Set Disabled - All Cafe
                              </Button>
                            </div>

                            <div className="CU_FlexRow">
                              <CalendarPicker
                                label="Start From"
                                // value={data?.visible_from_dt}
                                onDateChange={(e) => {
                                  console.log("e3", e);
                                  set_visible_from_dt_all("sub1", e);
                                  // set_visible_from_dt__byid(data?.id, e);
                                }}
                              />
                              <CalendarPicker
                                label="finished Until"
                                // value={data?.visible_from_dt}
                                onDateChange={(e) => {
                                  console.log("e3", e);
                                  set_visible_until_dt_all("sub1", e);
                                  // set_visible_from_dt__byid(data?.id, e);
                                }}
                              />
                            </div>
                            {/* {`adv_name : ${data?.adv_name} `} */}
                            <div className="CU_FlexRow CU_AlignItem_FlexEnd">
                              <TextInput
                                label="adv name (for log report)"
                                w="100%"
                                value={selected_adv_name_P}
                                placeholder="adv_name_P"
                                onChange={(event) =>
                                  setSelected_adv_name_P(
                                    event.currentTarget.value
                                  )
                                }
                              />
                              <Button
                                color="red"
                                variant="outline"
                                onClick={() => {
                                  console.log(
                                    "selected_adv_name_P",
                                    selected_adv_name_P
                                  );
                                  set_adv_name_all("sub1", selected_adv_name_P);
                                }}
                              >
                                Update
                              </Button>
                            </div>

                            {/* {`adv_url : ${data?.adv_url}`} */}
                            <div className="CU_FlexRow CU_AlignItem_FlexEnd">
                              <TextInput
                                label="open url when click (to disabled just remove all the text)"
                                w="100%"
                                value={selected_adv_url_P}
                                placeholder="adv_url"
                                onChange={(event) =>
                                  setSelected_adv_url_P(
                                    event.currentTarget.value
                                  )
                                }
                              />
                              <Button
                                color="red"
                                variant="outline"
                                onClick={() => {
                                  console.log(
                                    "selected_adv_url_P",
                                    selected_adv_url_P
                                  );
                                  set_adv_url_all("sub1", selected_adv_url_P);
                                }}
                              >
                                Update
                              </Button>
                            </div>
                            {/* {`adv_exepath : ${data?.adv_exepath}`} */}
                            <div className="CU_FlexRow CU_AlignItem_FlexEnd">
                              <TextInput
                                label="open exe when click (to disabled just remove all the text)"
                                w="100%"
                                value={selected_adv_exepath_P}
                                placeholder="adv_exepath"
                                onChange={(event) =>
                                  setSelected_adv_exepath_P(
                                    event.currentTarget.value
                                  )
                                }
                              />
                              <Button
                                color="red"
                                variant="outline"
                                onClick={() => {
                                  console.log(
                                    "selected_adv_exepath_P",
                                    selected_adv_exepath_P?.replaceAll(
                                      "\\",
                                      "\\\\"
                                    )
                                  );
                                  set_adv_exepath_all(
                                    "sub1",
                                    selected_adv_exepath_P?.replaceAll(
                                      "\\",
                                      "\\\\"
                                    )
                                  );
                                }}
                              >
                                Update
                              </Button>
                              {/* {selected_adv_exepath?.replaceAll("\\", "\\\\")} */}
                            </div>
                          </div>
                          <div>
                            <COM_Upload_IMG_v2__AllCafe
                              COM_Label="All Cafe - Sub1 Top Layer"
                              sto_DirPath={`./uploads/Eclipse_CareU/img/`}
                              // sto_FileName={`${fileNameToUpdload}__Top.png`}

                              // sto_FileName_List={[
                              //   `test_1.png`,
                              //   `test_2.png`,
                              //   `test_3.png`,
                              // ]}

                              sto_FileName_List={DB_AllCafeInfo?.cafelist?.map(
                                (x) => {
                                  let formatedCafeName = x?.cafe_name.replace(
                                    /\s+/g,
                                    "_"
                                  );

                                  // img_Gift_BBA__Poster_Main1__Bottom.jpg
                                  let tempFileName = `img_${formatedCafeName}__Poster_Sub1__Top.png`;
                                  return tempFileName;
                                }
                              )}
                              COM_Width="15rem"
                              COM_Height="20rem"
                              COM_fontsize=".5rem"
                            />
                          </div>
                          <div>
                            <COM_Upload_IMG_v2__AllCafe
                              COM_Label="All Cafe - Sub1 Middle Layer"
                              sto_DirPath={`./uploads/Eclipse_CareU/img/`}
                              // sto_FileName={`${fileNameToUpdload}__Top.png`}

                              sto_FileName_List={DB_AllCafeInfo?.cafelist?.map(
                                (x) => {
                                  let formatedCafeName = x?.cafe_name.replace(
                                    /\s+/g,
                                    "_"
                                  );

                                  // img_Gift_BBA__Poster_Main1__Bottom.jpg
                                  let tempFileName = `img_${formatedCafeName}__Poster_Sub1__Middle.png`;
                                  return tempFileName;
                                }
                              )}
                              COM_Width="15rem"
                              COM_Height="20rem"
                              COM_fontsize=".5rem"
                            />
                          </div>
                          <div>
                            <COM_Upload_IMG_v2__AllCafe
                              COM_Label="All Cafe - Sub1 Bottom Layer"
                              sto_DirPath={`./uploads/Eclipse_CareU/img/`}
                              // sto_FileName={`${fileNameToUpdload}__Top.png`}

                              sto_FileName_List={DB_AllCafeInfo?.cafelist?.map(
                                (x) => {
                                  let formatedCafeName = x?.cafe_name.replace(
                                    /\s+/g,
                                    "_"
                                  );

                                  // img_Gift_BBA__Poster_Main1__Bottom.jpg
                                  let tempFileName = `img_${formatedCafeName}__Poster_Sub1__Bottom.jpg`;
                                  return tempFileName;
                                }
                              )}
                              COM_Width="15rem"
                              COM_Height="20rem"
                              COM_fontsize=".5rem"
                            />
                          </div>
                        </div>
                        <br />
                        {/* ---------------------------------------------- all cafe sub2 */}
                        <div className="CU_FlexRow CU_Box_Group">
                          <div style={{ width: "40rem" }}>
                            <h2>sub2</h2>
                            <div className="CU_FlexRow">
                              <Button
                                color="lime"
                                variant="subtle"
                                onClick={() => {
                                  // set_adv_enabled__byid(data?.id, +!data?.adv_enabled);
                                  set_adv_enabled_all("sub2", 1);
                                }}
                              >
                                Set Enabled - All Cafe
                              </Button>
                              <Button
                                color="red"
                                variant="subtle"
                                onClick={() => {
                                  // set_adv_enabled__byid(data?.id, +!data?.adv_enabled);
                                  set_adv_enabled_all("sub2", 0);
                                }}
                              >
                                Set Disabled - All Cafe
                              </Button>
                            </div>

                            <div className="CU_FlexRow">
                              <CalendarPicker
                                label="Start From"
                                // value={data?.visible_from_dt}
                                onDateChange={(e) => {
                                  console.log("e3", e);
                                  set_visible_from_dt_all("sub2", e);
                                  // set_visible_from_dt__byid(data?.id, e);
                                }}
                              />
                              <CalendarPicker
                                label="finished Until"
                                // value={data?.visible_from_dt}
                                onDateChange={(e) => {
                                  console.log("e3", e);
                                  set_visible_until_dt_all("sub2", e);
                                  // set_visible_from_dt__byid(data?.id, e);
                                }}
                              />
                            </div>
                            {/* {`adv_name : ${data?.adv_name} `} */}
                            <div className="CU_FlexRow CU_AlignItem_FlexEnd">
                              <TextInput
                                label="adv name (for log report)"
                                w="100%"
                                value={selected_adv_name_P}
                                placeholder="adv_name_P"
                                onChange={(event) =>
                                  setSelected_adv_name_P(
                                    event.currentTarget.value
                                  )
                                }
                              />
                              <Button
                                color="red"
                                variant="outline"
                                onClick={() => {
                                  console.log(
                                    "selected_adv_name_P",
                                    selected_adv_name_P
                                  );
                                  set_adv_name_all("sub2", selected_adv_name_P);
                                }}
                              >
                                Update
                              </Button>
                            </div>

                            {/* {`adv_url : ${data?.adv_url}`} */}
                            <div className="CU_FlexRow CU_AlignItem_FlexEnd">
                              <TextInput
                                label="open url when click (to disabled just remove all the text)"
                                w="100%"
                                value={selected_adv_url_P}
                                placeholder="adv_url"
                                onChange={(event) =>
                                  setSelected_adv_url_P(
                                    event.currentTarget.value
                                  )
                                }
                              />
                              <Button
                                color="red"
                                variant="outline"
                                onClick={() => {
                                  console.log(
                                    "selected_adv_url_P",
                                    selected_adv_url_P
                                  );
                                  set_adv_url_all("sub2", selected_adv_url_P);
                                }}
                              >
                                Update
                              </Button>
                            </div>
                            {/* {`adv_exepath : ${data?.adv_exepath}`} */}
                            <div className="CU_FlexRow CU_AlignItem_FlexEnd">
                              <TextInput
                                label="open exe when click (to disabled just remove all the text)"
                                w="100%"
                                value={selected_adv_exepath_P}
                                placeholder="adv_exepath"
                                onChange={(event) =>
                                  setSelected_adv_exepath_P(
                                    event.currentTarget.value
                                  )
                                }
                              />
                              <Button
                                color="red"
                                variant="outline"
                                onClick={() => {
                                  console.log(
                                    "selected_adv_exepath_P",
                                    selected_adv_exepath_P?.replaceAll(
                                      "\\",
                                      "\\\\"
                                    )
                                  );
                                  set_adv_exepath_all(
                                    "sub2",
                                    selected_adv_exepath_P?.replaceAll(
                                      "\\",
                                      "\\\\"
                                    )
                                  );
                                }}
                              >
                                Update
                              </Button>
                              {/* {selected_adv_exepath?.replaceAll("\\", "\\\\")} */}
                            </div>
                          </div>
                          <div>
                            <COM_Upload_IMG_v2__AllCafe
                              COM_Label="All Cafe - Sub2 Top Layer"
                              sto_DirPath={`./uploads/Eclipse_CareU/img/`}
                              // sto_FileName={`${fileNameToUpdload}__Top.png`}

                              // sto_FileName_List={[
                              //   `test_1.png`,
                              //   `test_2.png`,
                              //   `test_3.png`,
                              // ]}

                              sto_FileName_List={DB_AllCafeInfo?.cafelist?.map(
                                (x) => {
                                  let formatedCafeName = x?.cafe_name.replace(
                                    /\s+/g,
                                    "_"
                                  );

                                  // img_Gift_BBA__Poster_Main1__Bottom.jpg
                                  let tempFileName = `img_${formatedCafeName}__Poster_Sub2__Top.png`;
                                  return tempFileName;
                                }
                              )}
                              COM_Width="15rem"
                              COM_Height="20rem"
                              COM_fontsize=".5rem"
                            />
                          </div>
                          <div>
                            <COM_Upload_IMG_v2__AllCafe
                              COM_Label="All Cafe - Sub2 Middle Layer"
                              sto_DirPath={`./uploads/Eclipse_CareU/img/`}
                              // sto_FileName={`${fileNameToUpdload}__Top.png`}

                              sto_FileName_List={DB_AllCafeInfo?.cafelist?.map(
                                (x) => {
                                  let formatedCafeName = x?.cafe_name.replace(
                                    /\s+/g,
                                    "_"
                                  );

                                  // img_Gift_BBA__Poster_Main1__Bottom.jpg
                                  let tempFileName = `img_${formatedCafeName}__Poster_Sub2__Middle.png`;
                                  return tempFileName;
                                }
                              )}
                              COM_Width="15rem"
                              COM_Height="20rem"
                              COM_fontsize=".5rem"
                            />
                          </div>
                          <div>
                            <COM_Upload_IMG_v2__AllCafe
                              COM_Label="All Cafe - Sub2 Bottom Layer"
                              sto_DirPath={`./uploads/Eclipse_CareU/img/`}
                              // sto_FileName={`${fileNameToUpdload}__Top.png`}

                              sto_FileName_List={DB_AllCafeInfo?.cafelist?.map(
                                (x) => {
                                  let formatedCafeName = x?.cafe_name.replace(
                                    /\s+/g,
                                    "_"
                                  );

                                  // img_Gift_BBA__Poster_Main1__Bottom.jpg
                                  let tempFileName = `img_${formatedCafeName}__Poster_Sub2__Bottom.jpg`;
                                  return tempFileName;
                                }
                              )}
                              COM_Width="15rem"
                              COM_Height="20rem"
                              COM_fontsize=".5rem"
                            />
                          </div>
                        </div>
                        <br />
                        {/* ---------------------------------------------- all cafe btn1 */}
                        <div className="CU_FlexRow CU_Box_Group">
                          <div style={{ width: "40rem" }}>
                            <h2>btn1</h2>
                            <div className="CU_FlexRow">
                              <Button
                                color="lime"
                                variant="subtle"
                                onClick={() => {
                                  // set_adv_enabled__byid(data?.id, +!data?.adv_enabled);
                                  set_adv_enabled_all("btn1", 1);
                                }}
                              >
                                Set Enabled - All Cafe
                              </Button>
                              <Button
                                color="red"
                                variant="subtle"
                                onClick={() => {
                                  // set_adv_enabled__byid(data?.id, +!data?.adv_enabled);
                                  set_adv_enabled_all("btn1", 0);
                                }}
                              >
                                Set Disabled - All Cafe
                              </Button>
                            </div>

                            <div className="CU_FlexRow">
                              <CalendarPicker
                                disabled
                                label="Start From"
                                // value={data?.visible_from_dt}
                                onDateChange={(e) => {
                                  console.log("e3", e);
                                  set_visible_from_dt_all("btn1", e);
                                  // set_visible_from_dt__byid(data?.id, e);
                                }}
                              />
                              <CalendarPicker
                                disabled
                                label="finished Until"
                                // value={data?.visible_from_dt}
                                onDateChange={(e) => {
                                  console.log("e3", e);
                                  set_visible_until_dt_all("btn1", e);
                                  // set_visible_from_dt__byid(data?.id, e);
                                }}
                              />
                            </div>
                            {/* {`adv_name : ${data?.adv_name} `} */}
                            <div className="CU_FlexRow CU_AlignItem_FlexEnd">
                              <TextInput
                                label="adv name (for log report)"
                                w="100%"
                                value={selected_adv_name_P}
                                placeholder="adv_name_P"
                                onChange={(event) =>
                                  setSelected_adv_name_P(
                                    event.currentTarget.value
                                  )
                                }
                              />
                              <Button
                                color="red"
                                variant="outline"
                                onClick={() => {
                                  console.log(
                                    "selected_adv_name_P",
                                    selected_adv_name_P
                                  );
                                  set_adv_name_all("btn1", selected_adv_name_P);
                                }}
                              >
                                Update
                              </Button>
                            </div>

                            {/* {`adv_url : ${data?.adv_url}`} */}
                            <div className="CU_FlexRow CU_AlignItem_FlexEnd">
                              <TextInput
                                label="open url when click (to disabled just remove all the text)"
                                w="100%"
                                value={selected_adv_url_P}
                                placeholder="adv_url"
                                onChange={(event) =>
                                  setSelected_adv_url_P(
                                    event.currentTarget.value
                                  )
                                }
                              />
                              <Button
                                color="red"
                                variant="outline"
                                onClick={() => {
                                  console.log(
                                    "selected_adv_url_P",
                                    selected_adv_url_P
                                  );
                                  set_adv_url_all("btn1", selected_adv_url_P);
                                }}
                              >
                                Update
                              </Button>
                            </div>
                            {/* {`adv_exepath : ${data?.adv_exepath}`} */}
                            <div className="CU_FlexRow CU_AlignItem_FlexEnd">
                              <TextInput
                                label="open exe when click (to disabled just remove all the text)"
                                w="100%"
                                value={selected_adv_exepath_P}
                                placeholder="adv_exepath"
                                onChange={(event) =>
                                  setSelected_adv_exepath_P(
                                    event.currentTarget.value
                                  )
                                }
                              />
                              <Button
                                color="red"
                                variant="outline"
                                onClick={() => {
                                  console.log(
                                    "selected_adv_exepath_P",
                                    selected_adv_exepath_P?.replaceAll(
                                      "\\",
                                      "\\\\"
                                    )
                                  );
                                  set_adv_exepath_all(
                                    "btn1",
                                    selected_adv_exepath_P?.replaceAll(
                                      "\\",
                                      "\\\\"
                                    )
                                  );
                                }}
                              >
                                Update
                              </Button>
                              {/* {selected_adv_exepath?.replaceAll("\\", "\\\\")} */}
                            </div>
                          </div>
                          <div>
                            <COM_Upload_IMG_v2__AllCafe
                              COM_Label="All Cafe - btn1 Top Layer"
                              sto_DirPath={`./uploads/Eclipse_CareU/img/`}
                              // sto_FileName={`${fileNameToUpdload}__Top.png`}

                              // sto_FileName_List={[
                              //   `test_1.png`,
                              //   `test_2.png`,
                              //   `test_3.png`,
                              // ]}

                              sto_FileName_List={DB_AllCafeInfo?.cafelist?.map(
                                (x) => {
                                  let formatedCafeName = x?.cafe_name.replace(
                                    /\s+/g,
                                    "_"
                                  );

                                  // img_Gift_BBA__Poster_Main1__Bottom.jpg
                                  let tempFileName = `img_${formatedCafeName}__Poster_Btn1__Top.png`;
                                  return tempFileName;
                                }
                              )}
                              COM_Width="15rem"
                              COM_Height="20rem"
                              COM_fontsize=".5rem"
                            />
                          </div>
                          <div>
                            <COM_Upload_IMG_v2__AllCafe
                              COM_Label="All Cafe - Btn1 Middle Layer"
                              sto_DirPath={`./uploads/Eclipse_CareU/img/`}
                              // sto_FileName={`${fileNameToUpdload}__Top.png`}

                              sto_FileName_List={DB_AllCafeInfo?.cafelist?.map(
                                (x) => {
                                  let formatedCafeName = x?.cafe_name.replace(
                                    /\s+/g,
                                    "_"
                                  );

                                  // img_Gift_BBA__Poster_Main1__Bottom.jpg
                                  let tempFileName = `img_${formatedCafeName}__Poster_Btn1__Middle.png`;
                                  return tempFileName;
                                }
                              )}
                              COM_Width="15rem"
                              COM_Height="20rem"
                              COM_fontsize=".5rem"
                            />
                          </div>
                          <div>
                            <COM_Upload_IMG_v2__AllCafe
                              COM_Label="All Cafe - Btn1 Bottom Layer"
                              sto_DirPath={`./uploads/Eclipse_CareU/img/`}
                              // sto_FileName={`${fileNameToUpdload}__Top.png`}

                              sto_FileName_List={DB_AllCafeInfo?.cafelist?.map(
                                (x) => {
                                  let formatedCafeName = x?.cafe_name.replace(
                                    /\s+/g,
                                    "_"
                                  );

                                  // img_Gift_BBA__Poster_Main1__Bottom.jpg
                                  let tempFileName = `img_${formatedCafeName}__Poster_Btn1__Bottom.jpg`;
                                  return tempFileName;
                                }
                              )}
                              COM_Width="15rem"
                              COM_Height="20rem"
                              COM_fontsize=".5rem"
                            />
                          </div>
                        </div>
                        <br />
                        {/* ---------------------------------------------- all cafe btn2 */}
                        <div className="CU_FlexRow CU_Box_Group">
                          <div style={{ width: "40rem" }}>
                            <h2>btn2</h2>
                            <div className="CU_FlexRow">
                              <Button
                                color="lime"
                                variant="subtle"
                                onClick={() => {
                                  // set_adv_enabled__byid(data?.id, +!data?.adv_enabled);
                                  set_adv_enabled_all("btn2", 1);
                                }}
                              >
                                Set Enabled - All Cafe
                              </Button>
                              <Button
                                color="red"
                                variant="subtle"
                                onClick={() => {
                                  // set_adv_enabled__byid(data?.id, +!data?.adv_enabled);
                                  set_adv_enabled_all("btn2", 0);
                                }}
                              >
                                Set Disabled - All Cafe
                              </Button>
                            </div>

                            <div className="CU_FlexRow">
                              <CalendarPicker
                                disabled
                                label="Start From"
                                // value={data?.visible_from_dt}
                                onDateChange={(e) => {
                                  console.log("e3", e);
                                  set_visible_from_dt_all("btn2", e);
                                  // set_visible_from_dt__byid(data?.id, e);
                                }}
                              />
                              <CalendarPicker
                                disabled
                                label="finished Until"
                                // value={data?.visible_from_dt}
                                onDateChange={(e) => {
                                  console.log("e3", e);
                                  set_visible_until_dt_all("btn2", e);
                                  // set_visible_from_dt__byid(data?.id, e);
                                }}
                              />
                            </div>
                            {/* {`adv_name : ${data?.adv_name} `} */}
                            <div className="CU_FlexRow CU_AlignItem_FlexEnd">
                              <TextInput
                                label="adv name (for log report)"
                                w="100%"
                                value={selected_adv_name_P}
                                placeholder="adv_name_P"
                                onChange={(event) =>
                                  setSelected_adv_name_P(
                                    event.currentTarget.value
                                  )
                                }
                              />
                              <Button
                                color="red"
                                variant="outline"
                                onClick={() => {
                                  console.log(
                                    "selected_adv_name_P",
                                    selected_adv_name_P
                                  );
                                  set_adv_name_all("btn2", selected_adv_name_P);
                                }}
                              >
                                Update
                              </Button>
                            </div>

                            {/* {`adv_url : ${data?.adv_url}`} */}
                            <div className="CU_FlexRow CU_AlignItem_FlexEnd">
                              <TextInput
                                label="open url when click (to disabled just remove all the text)"
                                w="100%"
                                value={selected_adv_url_P}
                                placeholder="adv_url"
                                onChange={(event) =>
                                  setSelected_adv_url_P(
                                    event.currentTarget.value
                                  )
                                }
                              />
                              <Button
                                color="red"
                                variant="outline"
                                onClick={() => {
                                  console.log(
                                    "selected_adv_url_P",
                                    selected_adv_url_P
                                  );
                                  set_adv_url_all("btn2", selected_adv_url_P);
                                }}
                              >
                                Update
                              </Button>
                            </div>
                            {/* {`adv_exepath : ${data?.adv_exepath}`} */}
                            <div className="CU_FlexRow CU_AlignItem_FlexEnd">
                              <TextInput
                                label="open exe when click (to disabled just remove all the text)"
                                w="100%"
                                value={selected_adv_exepath_P}
                                placeholder="adv_exepath"
                                onChange={(event) =>
                                  setSelected_adv_exepath_P(
                                    event.currentTarget.value
                                  )
                                }
                              />
                              <Button
                                color="red"
                                variant="outline"
                                onClick={() => {
                                  console.log(
                                    "selected_adv_exepath_P",
                                    selected_adv_exepath_P?.replaceAll(
                                      "\\",
                                      "\\\\"
                                    )
                                  );
                                  set_adv_exepath_all(
                                    "btn2",
                                    selected_adv_exepath_P?.replaceAll(
                                      "\\",
                                      "\\\\"
                                    )
                                  );
                                }}
                              >
                                Update
                              </Button>
                              {/* {selected_adv_exepath?.replaceAll("\\", "\\\\")} */}
                            </div>
                          </div>
                          <div>
                            <COM_Upload_IMG_v2__AllCafe
                              COM_Label="All Cafe - Btn2 Top Layer"
                              sto_DirPath={`./uploads/Eclipse_CareU/img/`}
                              // sto_FileName={`${fileNameToUpdload}__Top.png`}

                              // sto_FileName_List={[
                              //   `test_1.png`,
                              //   `test_2.png`,
                              //   `test_3.png`,
                              // ]}

                              sto_FileName_List={DB_AllCafeInfo?.cafelist?.map(
                                (x) => {
                                  let formatedCafeName = x?.cafe_name.replace(
                                    /\s+/g,
                                    "_"
                                  );

                                  // img_Gift_BBA__Poster_Main1__Bottom.jpg
                                  let tempFileName = `img_${formatedCafeName}__Poster_Btn2__Top.png`;
                                  return tempFileName;
                                }
                              )}
                              COM_Width="15rem"
                              COM_Height="20rem"
                              COM_fontsize=".5rem"
                            />
                          </div>
                          <div>
                            <COM_Upload_IMG_v2__AllCafe
                              COM_Label="All Cafe - Btn2 Middle Layer"
                              sto_DirPath={`./uploads/Eclipse_CareU/img/`}
                              // sto_FileName={`${fileNameToUpdload}__Top.png`}

                              sto_FileName_List={DB_AllCafeInfo?.cafelist?.map(
                                (x) => {
                                  let formatedCafeName = x?.cafe_name.replace(
                                    /\s+/g,
                                    "_"
                                  );

                                  // img_Gift_BBA__Poster_Main1__Bottom.jpg
                                  let tempFileName = `img_${formatedCafeName}__Poster_Btn2__Middle.png`;
                                  return tempFileName;
                                }
                              )}
                              COM_Width="15rem"
                              COM_Height="20rem"
                              COM_fontsize=".5rem"
                            />
                          </div>
                          <div>
                            <COM_Upload_IMG_v2__AllCafe
                              COM_Label="All Cafe - Btn2 Bottom Layer"
                              sto_DirPath={`./uploads/Eclipse_CareU/img/`}
                              // sto_FileName={`${fileNameToUpdload}__Top.png`}

                              sto_FileName_List={DB_AllCafeInfo?.cafelist?.map(
                                (x) => {
                                  let formatedCafeName = x?.cafe_name.replace(
                                    /\s+/g,
                                    "_"
                                  );

                                  // img_Gift_BBA__Poster_Main1__Bottom.jpg
                                  let tempFileName = `img_${formatedCafeName}__Poster_Btn2__Bottom.jpg`;
                                  return tempFileName;
                                }
                              )}
                              COM_Width="15rem"
                              COM_Height="20rem"
                              COM_fontsize=".5rem"
                            />
                          </div>
                        </div>
                        <br />
                        {/* ---------------------------------------------- all cafe btn3 */}
                        <div className="CU_FlexRow CU_Box_Group">
                          <div style={{ width: "40rem" }}>
                            <h2>btn3</h2>
                            <div className="CU_FlexRow">
                              <Button
                                color="lime"
                                variant="subtle"
                                onClick={() => {
                                  // set_adv_enabled__byid(data?.id, +!data?.adv_enabled);
                                  set_adv_enabled_all("btn3", 1);
                                }}
                              >
                                Set Enabled - All Cafe
                              </Button>
                              <Button
                                color="red"
                                variant="subtle"
                                onClick={() => {
                                  // set_adv_enabled__byid(data?.id, +!data?.adv_enabled);
                                  set_adv_enabled_all("btn3", 0);
                                }}
                              >
                                Set Disabled - All Cafe
                              </Button>
                            </div>

                            <div className="CU_FlexRow">
                              <CalendarPicker
                                disabled
                                label="Start From"
                                // value={data?.visible_from_dt}
                                onDateChange={(e) => {
                                  console.log("e3", e);
                                  set_visible_from_dt_all("btn3", e);
                                  // set_visible_from_dt__byid(data?.id, e);
                                }}
                              />
                              <CalendarPicker
                                disabled
                                label="finished Until"
                                // value={data?.visible_from_dt}
                                onDateChange={(e) => {
                                  console.log("e3", e);
                                  set_visible_until_dt_all("btn3", e);
                                  // set_visible_from_dt__byid(data?.id, e);
                                }}
                              />
                            </div>
                            {/* {`adv_name : ${data?.adv_name} `} */}
                            <div className="CU_FlexRow CU_AlignItem_FlexEnd">
                              <TextInput
                                label="adv name (for log report)"
                                w="100%"
                                value={selected_adv_name_P}
                                placeholder="adv_name_P"
                                onChange={(event) =>
                                  setSelected_adv_name_P(
                                    event.currentTarget.value
                                  )
                                }
                              />
                              <Button
                                color="red"
                                variant="outline"
                                onClick={() => {
                                  console.log(
                                    "selected_adv_name_P",
                                    selected_adv_name_P
                                  );
                                  set_adv_name_all("btn3", selected_adv_name_P);
                                }}
                              >
                                Update
                              </Button>
                            </div>

                            {/* {`adv_url : ${data?.adv_url}`} */}
                            <div className="CU_FlexRow CU_AlignItem_FlexEnd">
                              <TextInput
                                label="open url when click (to disabled just remove all the text)"
                                w="100%"
                                value={selected_adv_url_P}
                                placeholder="adv_url"
                                onChange={(event) =>
                                  setSelected_adv_url_P(
                                    event.currentTarget.value
                                  )
                                }
                              />
                              <Button
                                color="red"
                                variant="outline"
                                onClick={() => {
                                  console.log(
                                    "selected_adv_url_P",
                                    selected_adv_url_P
                                  );
                                  set_adv_url_all("btn3", selected_adv_url_P);
                                }}
                              >
                                Update
                              </Button>
                            </div>
                            {/* {`adv_exepath : ${data?.adv_exepath}`} */}
                            <div className="CU_FlexRow CU_AlignItem_FlexEnd">
                              <TextInput
                                label="open exe when click (to disabled just remove all the text)"
                                w="100%"
                                value={selected_adv_exepath_P}
                                placeholder="adv_exepath"
                                onChange={(event) =>
                                  setSelected_adv_exepath_P(
                                    event.currentTarget.value
                                  )
                                }
                              />
                              <Button
                                color="red"
                                variant="outline"
                                onClick={() => {
                                  console.log(
                                    "selected_adv_exepath_P",
                                    selected_adv_exepath_P?.replaceAll(
                                      "\\",
                                      "\\\\"
                                    )
                                  );
                                  set_adv_exepath_all(
                                    "btn3",
                                    selected_adv_exepath_P?.replaceAll(
                                      "\\",
                                      "\\\\"
                                    )
                                  );
                                }}
                              >
                                Update
                              </Button>
                              {/* {selected_adv_exepath?.replaceAll("\\", "\\\\")} */}
                            </div>
                          </div>
                          <div>
                            <COM_Upload_IMG_v2__AllCafe
                              COM_Label="All Cafe - Btn3 Top Layer"
                              sto_DirPath={`./uploads/Eclipse_CareU/img/`}
                              // sto_FileName={`${fileNameToUpdload}__Top.png`}

                              // sto_FileName_List={[
                              //   `test_1.png`,
                              //   `test_2.png`,
                              //   `test_3.png`,
                              // ]}

                              sto_FileName_List={DB_AllCafeInfo?.cafelist?.map(
                                (x) => {
                                  let formatedCafeName = x?.cafe_name.replace(
                                    /\s+/g,
                                    "_"
                                  );

                                  // img_Gift_BBA__Poster_Main1__Bottom.jpg
                                  let tempFileName = `img_${formatedCafeName}__Poster_Btn3__Top.png`;
                                  return tempFileName;
                                }
                              )}
                              COM_Width="15rem"
                              COM_Height="20rem"
                              COM_fontsize=".5rem"
                            />
                          </div>
                          <div>
                            <COM_Upload_IMG_v2__AllCafe
                              COM_Label="All Cafe - Btn3 Middle Layer"
                              sto_DirPath={`./uploads/Eclipse_CareU/img/`}
                              // sto_FileName={`${fileNameToUpdload}__Top.png`}

                              sto_FileName_List={DB_AllCafeInfo?.cafelist?.map(
                                (x) => {
                                  let formatedCafeName = x?.cafe_name.replace(
                                    /\s+/g,
                                    "_"
                                  );

                                  // img_Gift_BBA__Poster_Main1__Bottom.jpg
                                  let tempFileName = `img_${formatedCafeName}__Poster_Btn3__Middle.png`;
                                  return tempFileName;
                                }
                              )}
                              COM_Width="15rem"
                              COM_Height="20rem"
                              COM_fontsize=".5rem"
                            />
                          </div>
                          <div>
                            <COM_Upload_IMG_v2__AllCafe
                              COM_Label="All Cafe - Btn3 Bottom Layer"
                              sto_DirPath={`./uploads/Eclipse_CareU/img/`}
                              // sto_FileName={`${fileNameToUpdload}__Top.png`}

                              sto_FileName_List={DB_AllCafeInfo?.cafelist?.map(
                                (x) => {
                                  let formatedCafeName = x?.cafe_name.replace(
                                    /\s+/g,
                                    "_"
                                  );

                                  // img_Gift_BBA__Poster_Main1__Bottom.jpg
                                  let tempFileName = `img_${formatedCafeName}__Poster_Btn3__Bottom.jpg`;
                                  return tempFileName;
                                }
                              )}
                              COM_Width="15rem"
                              COM_Height="20rem"
                              COM_fontsize=".5rem"
                            />
                          </div>
                        </div>
                        <br />
                      </div>
                    </Modal>
                    <br />
                    <div className="CU_FlexRow">
                      <h2>{x?.cafe_name}</h2>
                      <Button
                        size="xl"
                        variant="filled"
                        color="dark"
                        onClick={() => {
                          window.open(
                            `http://localhost:7000/ccadv?cafe_name=${selectedCafe}&pc_name=pc001`,
                            "_b"
                          );
                        }}
                      >
                        🔍Local View
                      </Button>
                      <Button
                        size="xl"
                        variant="filled"
                        color="dark"
                        onClick={() => {
                          window.open(
                            `https://eclipsemy.com/ccadv?cafe_name=${selectedCafe}&pc_name=pc001`,
                            "_b"
                          );
                        }}
                      >
                        🔍Live View
                      </Button>
                    </div>
                    <div className=" CU_FlexColumn CU_Gap_1">
                      {DB_AllCafeInfo?.cafeinfolist
                        ?.filter((y) => y?.cafe_name === x?.cafe_name)
                        ?.map((z, zi) => {
                          let formatedCafeName = z?.cafe_name.replace(
                            /\s+/g,
                            "_"
                          );
                          let formatedAdvType = z?.adv_type?.replace(
                            /^./,
                            (c) => c.toUpperCase()
                          );
                          let fileNameToUpdload = `img_${formatedCafeName}__Poster_${formatedAdvType}`;
                          return (
                            <COMP_Card
                              key={zi}
                              data={z}
                              get_DB_GetAllCafeList={get_DB_GetAllCafeList}
                              fileNameToUpdload={fileNameToUpdload}
                              selectedCafe={selectedCafe}
                            />
                          );
                        })}
                    </div>
                  </div>
                ))}
            </div>
          ) : (
            "..."
          )}

          {selectedDisplayType === "buffet" ? (
            <div>
              <Comp_CareU_Buffet selectedCafe={selectedCafe} />
            </div>
          ) : (
            ""
          )}
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </div>
    </MantineProvider>
  );
};

const COMP_Card = ({
  data,
  get_DB_GetAllCafeList,
  fileNameToUpdload,
  selectedCafe,
}) => {
  const set_adv_enabled__byid = (id, adv_enabled) => {
    const confirmed = window.confirm(`Preoceed ?`);
    if (!confirmed) {
      return; // User clicked "No"
    }

    axios
      //REACT_APP_ECLIPSE_API
      .post(`${REACT_APP_ECLIPSE_API}/set__cafe_adv_list__adv_enabled_byid`, {
        id,
        adv_enabled,
      })
      .then((res) => {
        // setBD_CafeHardware(res.data);

        console.log("set_adv_enabled__byid", res?.data);
        get_DB_GetAllCafeList();
      });
  };

  const set_adv_name__byid = (id, adv_name) => {
    const confirmed = window.confirm(`Preoceed ?`);
    if (!confirmed) {
      return; // User clicked "No"
    }

    axios
      //REACT_APP_ECLIPSE_API
      .post(`${REACT_APP_ECLIPSE_API}/set__cafe_adv_list__adv_name_byid`, {
        id,
        adv_name,
      })
      .then((res) => {
        // setBD_CafeHardware(res.data);

        console.log("set_adv_name__byid", res?.data);
        get_DB_GetAllCafeList();
      });
  };

  const set_adv_url__byid = (id, adv_url) => {
    const confirmed = window.confirm(`Preoceed ?`);
    if (!confirmed) {
      return; // User clicked "No"
    }

    axios
      //REACT_APP_ECLIPSE_API
      .post(`${REACT_APP_ECLIPSE_API}/set__cafe_adv_list__adv_url_byid`, {
        id,
        adv_url,
      })
      .then((res) => {
        // setBD_CafeHardware(res.data);

        console.log("set_adv_url__byid", res?.data);
        get_DB_GetAllCafeList();
      });
  };

  const set_adv_exepath__byid = (id, adv_exepath) => {
    const confirmed = window.confirm(`Preoceed ?`);
    if (!confirmed) {
      return; // User clicked "No"
    }

    axios
      //REACT_APP_ECLIPSE_API
      .post(`${REACT_APP_ECLIPSE_API}/set__cafe_adv_list__adv_exepath_byid`, {
        id,
        adv_exepath,
      })
      .then((res) => {
        // setBD_CafeHardware(res.data);

        console.log("set_adv_exepath__byid", res?.data);
        get_DB_GetAllCafeList();
      });
  };

  const set_visible_from_dt__byid = (id, visible_from_dt) => {
    const confirmed = window.confirm(`Preoceed ?`);
    if (!confirmed) {
      return; // User clicked "No"
    }

    axios
      //REACT_APP_ECLIPSE_API
      .post(
        `${REACT_APP_ECLIPSE_API}/set__cafe_adv_list__visible_from_dt_byid`,
        {
          id,
          visible_from_dt,
        }
      )
      .then((res) => {
        // setBD_CafeHardware(res.data);

        console.log("set_visible_from_dt__byid", res?.data);
        get_DB_GetAllCafeList();
      });
  };

  const set_visible_until_dt__byid = (id, visible_until_dt) => {
    const confirmed = window.confirm(`Preoceed ?`);
    if (!confirmed) {
      return; // User clicked "No"
    }

    axios
      //REACT_APP_ECLIPSE_API
      .post(
        `${REACT_APP_ECLIPSE_API}/set__cafe_adv_list__visible_until_dt_byid`,
        {
          id,
          visible_until_dt,
        }
      )
      .then((res) => {
        // setBD_CafeHardware(res.data);

        console.log("set_visible_until_dt__byid", res?.data);
        get_DB_GetAllCafeList();
      });
  };

  const [selected_adv_name, setSelected_adv_name] = useState(
    data?.adv_name ?? ""
  );
  const [selected_adv_url, setSelected_adv_url] = useState(data?.adv_url ?? "");
  const [selected_adv_exepath, setSelected_adv_exepath] = useState(
    data?.adv_exepath ?? ""
  );

  useEffect(() => {
    console.log("card , data?.adv_type", data?.adv_type);
    console.log("card , data", data);

    setSelected_adv_name(data?.adv_name ?? "");
    setSelected_adv_url(data?.adv_url ?? "");
    setSelected_adv_exepath(data?.adv_exepath ?? "");
  }, [data?.id]);

  useEffect(() => {
    // setSelected_adv_name("");
    // setSelected_adv_url("");
    // setSelected_adv_exepath("");
  }, []);

  return (
    <div className="CU_FlexRow CU_Box_Group">
      <div style={{ width: "40rem" }}>
        <div
          style={{ color: "gold", fontSize: "1.5rem" }}
          className="CU_FlexRow"
        >
          {`${data?.adv_enabled === 1 ? "✅" : "❌"} ${data?.adv_type} `}
          <Button
            color={data?.adv_enabled === 1 ? "red" : "lime"}
            variant="subtle"
            onClick={() => {
              set_adv_enabled__byid(data?.id, +!data?.adv_enabled);
            }}
          >
            {data?.adv_enabled === 1 ? "Set Disabled" : "Set Enabled"}
          </Button>
        </div>
        {/* {`id : ${data?.id}  `} */}

        {/* <div
          style={{
            color: data?.adv_enabled === 1 ? "lime" : "red",
          }}
        >
          {`adv_enabled : ${data?.adv_enabled}  `}
        </div> */}

        {/* {`visible_from_dt  :  ${data?.visible_from_dt}`} */}
        <div className="CU_FlexRow CU_Gap_0D5">
          <CalendarPicker
            label="Start From"
            value={data?.visible_from_dt}
            onDateChange={(e) => {
              console.log("e1", e);
              set_visible_from_dt__byid(data?.id, e);
            }}
          />

          {/* {`visible_until_dt : ${data?.visible_until_dt}`} */}
          <CalendarPicker
            label="Finished Unil"
            value={data?.visible_until_dt}
            onDateChange={(e) => {
              console.log("e2", e);
              set_visible_until_dt__byid(data?.id, e);
            }}
          />
        </div>

        {/* {`adv_name : ${data?.adv_name} `} */}
        <div className="CU_FlexRow CU_AlignItem_FlexEnd">
          <TextInput
            label="adv name (for log report)"
            w="100%"
            value={selected_adv_name}
            placeholder="adv_name"
            onChange={(event) =>
              setSelected_adv_name(event.currentTarget.value)
            }
          />
          <Button
            color="red"
            variant="outline"
            onClick={() => {
              console.log("selected_adv_name", selected_adv_name);
              set_adv_name__byid(data?.id, selected_adv_name);
            }}
          >
            Update
          </Button>
        </div>

        {/* {`adv_url : ${data?.adv_url}`} */}
        <div className="CU_FlexRow CU_AlignItem_FlexEnd">
          <TextInput
            label="open url when click (to disabled just remove all the text)"
            w="100%"
            value={selected_adv_url}
            placeholder="adv_url"
            onChange={(event) => setSelected_adv_url(event.currentTarget.value)}
          />
          <Button
            color="red"
            variant="outline"
            onClick={() => {
              console.log("selected_adv_url", selected_adv_url);
              set_adv_url__byid(data?.id, selected_adv_url);
            }}
          >
            Update
          </Button>
        </div>
        {/* {`adv_exepath : ${data?.adv_exepath}`} */}
        <div className="CU_FlexRow CU_AlignItem_FlexEnd">
          <TextInput
            label="open exe when click (to disabled just remove all the text)"
            w="100%"
            value={selected_adv_exepath}
            placeholder="adv_exepath"
            onChange={(event) =>
              setSelected_adv_exepath(event.currentTarget.value)
            }
          />
          <Button
            color="red"
            variant="outline"
            onClick={() => {
              console.log(
                "selected_adv_exepath",
                selected_adv_exepath?.replaceAll("\\", "\\\\")
              );
              set_adv_exepath__byid(
                data?.id,
                selected_adv_exepath?.replaceAll("\\", "\\\\")
              );
            }}
          >
            Update
          </Button>
          {/* {selected_adv_exepath?.replaceAll("\\", "\\\\")} */}
        </div>
      </div>
      <div>
        <COM_Upload_IMG_v2
          COM_Label="Main Top Layer"
          sto_DirPath={`./uploads/Eclipse_CareU/img/`}
          sto_FileName={`${fileNameToUpdload}__Top.png`}
          COM_Width="15rem"
          COM_Height="20rem"
          COM_fontsize=".5rem"
        />
      </div>

      <div>
        <COM_Upload_IMG_v2
          COM_Label="Main Middle Layer"
          sto_DirPath={`./uploads/Eclipse_CareU/img/`}
          sto_FileName={`${fileNameToUpdload}__Middle.png`}
          COM_Width="15rem"
          COM_Height="20rem"
          COM_fontsize=".5rem"
        />
      </div>

      <div>
        <COM_Upload_IMG_v2
          COM_Label="Main Bottom Layer"
          sto_DirPath={`./uploads/Eclipse_CareU/img/`}
          sto_FileName={`${fileNameToUpdload}__Bottom.jpg`}
          COM_Width="15rem"
          COM_Height="20rem"
          COM_fontsize=".5rem"
        />
      </div>
    </div>
  );
};

const CalendarPicker = ({ value, onDateChange, label = "" }) => {
  const [selectedDate, setSelectedDate] = useState(new Date()); // default to today

  const convertToDateString = (dateTimeStr) => {
    if (!dateTimeStr || typeof dateTimeStr !== "string") {
      return new Date(); // default to today if invalid
    }

    const isoFormattedStr = dateTimeStr.replace(" ", "T");
    const parsedDate = new Date(isoFormattedStr);

    return isNaN(parsedDate) ? new Date() : parsedDate; // fallback to today
  };

  const formatDateToYMD = (input) => {
    const date = new Date(input);
    if (isNaN(date)) throw new Error("Invalid date input");

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    setSelectedDate(convertToDateString(value));
  }, [value]);
  return (
    <div className="CU_Calendar_Container">
      {/* <div>{`selectedDate: ${selectedDate}`}</div> */}
      {/* <div>{`value: ${value}`}</div> */}
      {/* <div>{`convertToDateString(value): ${convertToDateString(value)}`}</div> */}
      {/* ie. value:  2025-07-03 00:00:00  */}
      <div>{label}</div>
      <Calendar
        value={selectedDate}
        initialMonth={convertToDateString(value)}
        onChange={(e) => {
          // console.log("e", e);
          setSelectedDate(e);
          onDateChange(formatDateToYMD(e));
        }}
      />
    </div>
  );
};

export default Page_CareU;
